export type FeatureFlags = Record<string, boolean>;

export const resolveFeatureFlags = (divisions: Array<{ code: string; features?: Array<{ name?: string; status?: boolean }> }>, divisionCode: string): FeatureFlags => {
       const division = divisions.find(div => div.code === divisionCode);
       if (!division?.features) return {};

       return division.features.reduce<FeatureFlags>((acc, feature) => {
              if (feature?.name) {
                     acc[feature.name] = !!feature.status;
              }
              return acc;
       }, {});
};
